var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 417.95728,
    height: 449.38788,
    viewBox: "0 0 110.58452 118.90053",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-3.19423e-6,-178.09938)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D7 \\uE4E6",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4293",
    transform: "matrix(13.904947,0,0,13.904333,-208.11659,-2895.4341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4297",
    style: {
      strokeWidth: 2.38434362
    },
    d: "m 21.946325,223.40869 c -0.433917,-0.66675 -0.79375,-1.36525 -0.92075,-2.18016 -0.03175,-0.13759 -0.09525,-0.17992 -0.254,-0.17992 -0.04233,0 -0.08467,0.0106 -0.08467,0.0741 v 0.0106 c 0,0 0,0.0212 0,0.0423 v 1.98967 c 0,0 0,0 0,0 v 4.27566 c -0.169333,-0.14816 -0.402167,-0.22225 -0.677333,-0.22225 -1.04775,0 -1.883834,0.77259 -1.883834,1.5875 0,0.49742 0.402167,0.79375 0.92075,0.79375 0.846667,0 1.894417,-0.78316 1.894417,-1.5875 v -4.75191 c 0.518583,0.32808 1.143,1.25941 1.407583,1.87325 0.127,0.28575 0.201084,0.77258 0.201084,1.27 0,0.381 -0.05292,0.78316 -0.201084,1.16416 -0.01058,0.0423 -0.02117,0.0847 -0.02117,0.127 0,0.127 0.08467,0.21167 0.137583,0.24342 l 0.01058,0.0106 c 0.07408,0 0.179917,-0.0317 0.22225,-0.16933 0,0 0.22225,-0.80433 0.22225,-1.47108 0,-1.05834 -0.4445,-2.05317 -0.973666,-2.89984 z m -5.846818,0.20436 c 0,-0.30692 -0.254,-0.56092 -0.560917,-0.56092 -0.3175,0 -0.5715,0.254 -0.5715,0.56092 0,0.17992 0.105834,0.33867 0.232834,0.43392 0.07408,0.0529 0.148166,0.0952 0.232833,0.11641 0.0635,0.0106 0.148167,0.0317 0.22225,0.0317 0.116417,0 0.232833,-0.0317 0.328083,-0.0635 0.116417,-0.0317 0.1905,-0.0635 0.306917,-0.127 0.01058,-0.0106 0.03175,-0.0106 0.04233,-0.0106 0.03175,0 0.04233,0.0423 0.04233,0.0847 0,0.0212 0,0.0529 -0.01058,0.0847 -0.02117,0.127 -0.635,1.82034 -0.783166,2.37067 0,0.10583 0.1905,0.11642 0.243416,0.11642 0.09525,0 0.211667,-0.0212 0.296334,-0.0847 0.02117,-0.0212 0.85725,-2.99508 0.85725,-2.99508 0.03175,-0.14817 0.07408,-0.28575 0.08467,-0.32809 0,-0.0847 -0.08467,-0.127 -0.105833,-0.13758 -0.02117,0 -0.04233,0 -0.09525,0.0423 -0.05292,0.0423 -0.47625,0.55034 -0.762,0.55034 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEre);
export default __webpack_public_path__ + "static/media/ere.47a5cafe56b6980787079766c608a032.svg";
export { ForwardRef as ReactComponent };